import { Box, Text } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { Expensable } from 'modules/expenses/types/Expensable'

import CustomWidgetHeaderButton from './CustomWidgetHeaderButton'

interface InternalReferenceWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
}

const InternalReferenceWidget = ({
  expensable,
  editable,
  onEdit,
}: InternalReferenceWidgetProps) => {
  const internalReference = expensable?.internalReference ?? ''
  if (!internalReference) {
    return null
  }

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.internal_reference_block.title'),
        }}
      >
        <Text size="200" weight="normal">
          {internalReference}
        </Text>
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default InternalReferenceWidget
